// extracted by mini-css-extract-plugin
export var dividerLine = "_64-3";
export var itemImage = "_64-9";
export var lightDivider = "_64-4";
export var modalContent = "_64-5";
export var modalContentCompact = "_64-6";
export var productCard = "_64-a";
export var productImage = "_64-b";
export var productImageCompact = "_64-7";
export var productImagePlaceholder = "_64-c";
export var productImagePlaceholderCompact = "_64-8";
export var progressBarBackground = "_64-1";
export var progressBarContainer = "_64-0";
export var progressBarFill = "_64-2";